import React from "react";
import { Link } from "react-router-dom";
export const SiteMap = () => {
    return (React.createElement("div", { className: "container" },
        React.createElement("div", { className: "cms-article cms-single-panel" },
            React.createElement("h1", null, "Mapa str\u00E1nek"),
            React.createElement("ul", null,
                React.createElement("li", null,
                    "Aukce",
                    React.createElement("ul", null,
                        React.createElement("li", null,
                            React.createElement(Link, { to: "/cs/seznam/nejblizsi-aukce" }, "Nejbli\u017E\u0161\u00ED aukce")),
                        React.createElement("li", null,
                            React.createElement(Link, { to: "/cs/seznam/probihajici-aukce" }, "Prob\u00EDhaj\u00EDc\u00ED aukce")),
                        React.createElement("li", null,
                            React.createElement(Link, { to: "/cs/seznam/ukoncene-aukce" }, "Ukon\u010Den\u00E9 aukce")))),
                React.createElement("li", null,
                    "U\u017Eivatelsk\u00FD \u00FA\u010Det",
                    React.createElement("ul", null,
                        React.createElement("li", null,
                            React.createElement(Link, { to: "/cs/proces/registrace" }, "Registrace do syst\u00E9mu elektronick\u00FDch aukc\u00ED")),
                        React.createElement("li", null,
                            React.createElement(Link, { to: "/cs/proces/prihlaseni-uzivatele" }, "P\u0159ihl\u00E1\u0161en\u00ED do syst\u00E9mu elektronick\u00FDch aukc\u00ED")),
                        React.createElement("li", null,
                            React.createElement(Link, { to: "/cs/proces/zapomenute-heslo" }, "Zapomenut\u00E9 heslo")))),
                React.createElement("li", null,
                    "Pou\u017Eit\u00ED aplikace",
                    React.createElement("ul", null,
                        React.createElement("li", null,
                            " ",
                            React.createElement(Link, { to: "/cs/sekce/souhlas-se-zpracovanim-osobnich-udaju", className: "link" },
                                React.createElement("span", { className: "text" }, "Souhlas se zpracov\u00E1n\u00EDm osobn\u00EDch \u00FAdaj\u016F"))),
                        React.createElement("li", null,
                            React.createElement(Link, { to: "/cs/seznam/podminky-ucasti" }, "Podm\u00EDnky \u00FA\u010Dasti v elektronick\u00E9 aukci")),
                        React.createElement("li", null,
                            React.createElement(Link, { to: "/cs/sekce/software-tretich-stran" }, "Software t\u0159et\u00EDch stran")),
                        React.createElement("li", null,
                            React.createElement(Link, { to: "/cs/seznam/ukoncene-aukce" }, "Ukon\u010Den\u00E9 aukce"))))))));
};
